import { useSelector } from "react-redux";
import styled from "styled-components";
import * as styles from "styles";
import * as Types from "Types";

const Wrap = styled.div<Types.Default>`
   ${({ css }) => css}
`;

function GridChild(props: Types.Grid.Child) {
   const windowWidth = useSelector(({ dimensions }: Types.State) => dimensions.width);
   const width = props.width || windowWidth;
   const shows = (props.shows && styles.shows(props.shows)) || true;

   return (
      (shows && (
         <Wrap css={styles.gridColumns({ ...props, width })} style={props.style}>
            {props.children}
         </Wrap>
      )) ||
      null
   );
}
export default GridChild;
